module.exports = __webpack_public_path__ + "static/media/addCardPage.ba1a1255.png";